/**
 * Baut den Request-Body für Create/Update eines Timerecorddetails aus dem Formularwert — als Kopie, das Formular selbst bleibt unverändert.
 * - `timerecord.user` wird entfernt (enthält private Mitarbeiterdaten und wird vom Backend nicht gebraucht)
 * - leere Zeitfelder ('' vom nativen time-Input) werden zu null, sonst lehnt MySQL den Wert ab
 */
export const getCreateUpdateTimerecorddetailPayload = function <
  T extends { timerecord?: { user?: unknown } | null; timeStart?: string | null; timeEnd?: string | null },
>(formValue: T): T {
  return {
    ...formValue,
    ...(formValue.timerecord && { timerecord: { ...formValue.timerecord, user: undefined } }),
    ...(formValue.timeStart === '' && { timeStart: null }),
    ...(formValue.timeEnd === '' && { timeEnd: null }),
  } as T;
};
